<script setup>
import { useStore } from 'vuex';
import LogoSVG from '@/assets/logos/clearco-logo.svg';
import { computed } from 'vue';
import { RouteNames } from '@/data/routes';
import { useRouter } from 'vue-router';

const store = useStore();
const router = useRouter();

const emits = defineEmits(['click']);

const logoRoute = computed(() => {
  const activeMCAUser =
    store.getters.userHasAdvanceOffer || !!store.getters.activeAdvances.length;
  const hasAvailableAdvanceCredit = store.getters.userHasAvailableAdvanceCredit;
  if (
    store.getters.bills.length ||
    (!activeMCAUser && !hasAvailableAdvanceCredit)
  ) {
    return RouteNames.HOME.INITIAL;
  } else if (hasAvailableAdvanceCredit) {
    return RouteNames.MCA.SPEND;
  }
  return router.currentRoute.value.name;
});

const props = defineProps({
  mobile: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <router-link
    :to="{ name: logoRoute }"
    data-cy="header-logo-link"
    :class="props.mobile ? undefined : $style['desktop-sidebar-logo']"
    aria-label="Home"
    @click="emits('click')"
  >
    <LogoSVG
      :class="props.mobile ? $style['mobile-sidebar-logo'] : undefined"
    />
  </router-link>
</template>

<style lang="less" module>
.mobile-sidebar-logo {
  display: none;
  width: 170px;
  height: auto;
  @media only screen and (max-width: @wayfinding-tablet-width) {
    display: block;
  }
}
.desktop-sidebar-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;

  svg {
    width: 170px;
    height: auto;
  }
}
</style>
